import { render, staticRenderFns } from "./AsideBarItem.vue?vue&type=template&id=b770eef8&scoped=true"
import script from "./AsideBarItem.vue?vue&type=script&lang=js"
export * from "./AsideBarItem.vue?vue&type=script&lang=js"
import style0 from "./AsideBarItem.vue?vue&type=style&index=0&id=b770eef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b770eef8",
  null
  
)

export default component.exports